import axios from 'axios'

const state = {

};

const mutations = {

};

const actions = {
  sendEmail({commit}, emailInfo) {
    console.log(emailInfo.email)
    console.log(emailInfo.userID)
    axios.post('/optimum/email/',
        {
          subject: emailInfo.subject,
          message: emailInfo.message,
          from_address: emailInfo.from,
          to_address: emailInfo.email,
          reply_address: emailInfo.reply,
          user_id: emailInfo.userID,
        }
      )
        .then(res => {
          console.log('Email Sent')
          console.log(res)
        })
        .catch(error => console.log(error))
  },
};

const getters = {

};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/communication.js